/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/camelcase */
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import i18n from 'i18n';
import {
  getDashboardPartnerRequest,
  getDashboardRequest,
} from 'modules/dashboard/actions';
import {
  DashboardDataCompanyFields,
  DashboardDataCompanyPartnerFields,
} from 'modules/dashboard/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { formatPercent, manipulateLocalStorage } from 'utils/helpers';
import { CompanyData, PartnerData } from 'modules/authenticate/interfaces';
import MainPanelTemplate from '../templates';

interface Props {
  companyDashboardPartnerData: DashboardDataCompanyPartnerFields;
  companyDashboardData: DashboardDataCompanyFields;
  companySelected: CompanyData | null;
  isLoading: boolean;
  operator_uuid: string;
  partnerSelected: PartnerData | null;
  getDashboardRequest: (props) => void;
  getDashboardPartnerRequest: (props) => void;
}

export const LOCAL_STORAGE_PREFERENCE_KEY = (operator_uuid: string) => {
  return `autoSky@:${operator_uuid}-dashboard-preferences`;
};

export const addInDashboard = (
  item: any,
  listPreference: any[],
  operator_uuid: string
) => {
  if (listPreference?.length === 0) {
    const data = {
      type: item?.type,
      key: item?.key,
      title: item?.title,
    };
    if (item?.footer) {
      Object.assign(data, {
        footer: {
          name: item?.footer[0].name,
          link: item?.footer[0].link,
        },
      });
    }
    manipulateLocalStorage(LOCAL_STORAGE_PREFERENCE_KEY(operator_uuid), [data]);
    return [data];
  }

  const exist = listPreference.find(preference => preference.key === item?.key);
  if (exist) {
    const index = listPreference.indexOf(exist);
    listPreference.splice(index, 1);
    manipulateLocalStorage(
      LOCAL_STORAGE_PREFERENCE_KEY(operator_uuid),
      listPreference
    );
    return listPreference;
  }
  const data = {
    type: item?.type,
    key: item?.key,
    title: item?.title,
  };
  if (item?.footer) {
    Object.assign(data, {
      footer: {
        name: item?.footer[0].name,
        link: item?.footer[0].link,
      },
    });
  }
  manipulateLocalStorage(LOCAL_STORAGE_PREFERENCE_KEY(operator_uuid), [
    ...listPreference,
    data,
  ]);
  return [...listPreference, data];
};

export const listItensDashboard = (operator_uuid: string) => {
  const dashboardList = manipulateLocalStorage(
    LOCAL_STORAGE_PREFERENCE_KEY(operator_uuid)
  );
  if (dashboardList) {
    return dashboardList;
  }
  return [];
};

const MainPanel = ({
  companyDashboardData,
  companyDashboardPartnerData,
  companySelected,
  isLoading,
  operator_uuid,
  partnerSelected,
  getDashboardRequest,
  getDashboardPartnerRequest,
}: Props) => {
  const [listItens, setListItens] = React.useState<any[]>([]);

  React.useEffect(() => {
    const existCompany = listItens.find(item => item?.type === 'company');
    const existPartner = listItens.find(item => item?.type === 'partner');

    if (existCompany && companySelected) {
      getDashboardRequest({ companyUuid: companySelected?.id });
    }
    if (existPartner && companySelected && partnerSelected) {
      getDashboardPartnerRequest({
        companyUuid: companySelected.id,
        partnerUuid: partnerSelected.id,
      });
    }
  }, [
    companySelected,
    getDashboardPartnerRequest,
    getDashboardRequest,
    listItens,
    partnerSelected,
  ]);

  React.useEffect(() => {
    const dashboardList = listItensDashboard(operator_uuid);
    if (dashboardList) {
      setListItens(dashboardList);
    }
  }, [operator_uuid]);

  // eslint-disable-next-line consistent-return
  const makeValues = (type: string, key: string) => {
    if (key) {
      const [, value] = key.split('summary.');

      const values = {
        company: companyDashboardData?.summary[value] || 0,
        partner:
          value === 'environments_with_instances_percent'
            ? formatPercent(companyDashboardPartnerData.summary[value])
            : companyDashboardPartnerData.summary[value],
      };
      return values[type];
    }
  };

  return (
    <MainPanelTemplate
      headerPage={{
        title: i18n.t('PANEL_PAGE.PANEL_AUTO_KEY'),
        subtitle: i18n.t('PANEL_PAGE.FAVORITES_CARDS_KEY'),
      }}
      cardLoading={isLoading}
      cards={listItens.map(item => ({
        key: item?.key,
        title: i18n.t(item?.title),
        value: makeValues(item?.type, item?.key),
        type: item?.type,
        hasType: true,
        footer: item?.footer && [
          {
            name: item?.footer.name,
            link: item?.footer.link,
            icon: <ArrowRightAltIcon />,
          },
        ],
      }))}
    />
  );
};

const mapStateToProps = ({
  dashboard: { companyDashboardData, companyDashboardPartnerData, isLoading },
  authenticate: { companySelected, partnerSelected, data },
}: ApplicationState) => ({
  companyDashboardData,
  companyDashboardPartnerData,
  partnerSelected,
  companySelected,
  isLoading,
  operator_uuid: data?.operator_uuid!,
});

export default connect(mapStateToProps, {
  getDashboardRequest,
  getDashboardPartnerRequest,
})(MainPanel);
